import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  
  setCookie(name: string, value: string, days: number = 1): void {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  deleteCookie(name: string): void {
    this.setCookie(name, '', -1); // Süresi geçmiş bir tarih ile yeniden yazılır ve bu şekilde silinir.
  }

  getAllCookies(): { [key: string]: string } {
    const cookies: { [key: string]: string } = {};
    const cookiesArray = document.cookie.split(';');
    for (let cookie of cookiesArray) {
      const [name, value] = cookie.split('=');
      if (name && value) {
        cookies[name.trim()] = value.trim();
      }
    }
    return cookies;
  }
}
